export default __webpack_public_path__ + "static/media/pin.77b67cf4.svg";